import { render, staticRenderFns } from "./TeeTimeSummary.vue?vue&type=template&id=61644a88"
import script from "./TeeTimeSummary.vue?vue&type=script&lang=ts"
export * from "./TeeTimeSummary.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports